import React from 'react';
import { Flex, Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
// components
import { ToggleSwitch } from '../../../../components';
import { AiSectionGroup, AiTypesConfigData } from '../types';
import useUserDateTimeFormat from '@/hooks/useUserDateTimeFormat';

interface AiControlTableProps {
  group: AiSectionGroup;
  displaySection?: string;
  onToggleChange: (id: string, value: boolean) => void; // NEW callback
}

const AiControlTable: React.FC<AiControlTableProps> = ({
  group,
  displaySection,
  onToggleChange,
}) => {
  const { formatDateTime } = useUserDateTimeFormat();
  const columns: ColumnsType<AiTypesConfigData> = [
    // toggle button and name
    {
      title: displaySection || '--',
      key: 'action',
      width: '60%',
      render: (_, rule) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <ToggleSwitch
              labelStyle={'alert-customization-bg'}
              label=''
              checked={rule?.is_enabled}
              onChange={(e) => onToggleChange(rule.id, e.target.checked)}
            />
          </div>

          <Flex vertical className='rule-container'>
            <p className='rule-title'>{rule?.title}</p>
            <p className='rule-description'>{rule?.description}</p>
          </Flex>
        </div>
      ),
    },
    // Last update time
    {
      title: 'Last updated',
      key: 'updated_at',
      width: 130,
      render: (_, rule) => {
        const formatted = formatDateTime(rule?.updated_at);

        return (
          <Typography.Text
            ellipsis={{ tooltip: formatted }}
            style={{
              display: 'block',
              maxWidth: 120,
            }}
          >
            {formatted}
          </Typography.Text>
        );
      },
    },
    // Update by name
    {
      title: 'By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: 160,
      render: (text) => (
        <Typography.Text
          ellipsis={{ tooltip: text }}
          style={{
            display: 'block',
            maxWidth: 150,
          }}
        >
          {text}
        </Typography.Text>
      ),
    },
  ];

  return (
    <div className='settings-content-wrapper'>
      <Table
        columns={columns}
        dataSource={group.ai_types.map((r) => ({ ...r, key: r.id }))}
        pagination={false}
        rowHoverable={false}
        size='small'
        className='settings-table ai-contorls-table'
        rowClassName={(_, index) =>
          index === group.ai_types?.length - 1 ? 'no-bottom-border' : ''
        }
      />
    </div>
  );
};
export default AiControlTable;
